module.exports = "<!--<app-aside-nav style=\"overflow: scroll\" *ngIf=\"appService.canShowSideNav\"></app-aside-nav>-->\n<router-outlet *ngIf=\"appService.canShowSideNav\"></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /mnt/volume_sfo2_01/www/html/mafe-dev/src/app/theme/pages/default/default.component.html
// module id = ../../../../../src/app/theme/pages/default/default.component.html
// module chunks = main